import { MoneyInput } from '../../components/MoneyInput/MoneyInput';
import { Button } from '../../components/Button/Button';
import { fmtN } from '../../lib/format';
import { MONTH_SHORT } from '../../lib/dates';
import type { Goal } from '@budgetx/shared';
import styles from './OpsparingPrMaanedTable.module.css';

interface Props {
  year: number;
  monthIdx: number;
  goals: Goal[];
  onEditAmount(goalId: number, month: number, next: number | null): void;
  onCreateInline(): void;
  onRenameGoal(goalId: number, name: string): void;
  onDeleteGoal(goalId: number, name: string): void;
}

export function OpsparingPrMaanedTable({
  year,
  monthIdx,
  goals,
  onEditAmount,
  onCreateInline,
  onRenameGoal,
  onDeleteGoal,
}: Props) {
  const totals: (number | null)[] = Array(12).fill(null);
  for (let m = 0; m < 12; m++) {
    let sum = 0;
    let any = false;
    for (const g of goals) {
      const v = g.amounts[m];
      if (v !== null && v !== undefined) {
        sum += v;
        any = true;
      }
    }
    totals[m] = any ? sum : null;
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.headRow}>
        <h2 className={styles.title}>Opsparing pr. måned · {year}</h2>
        <Button onClick={onCreateInline}>+ Ny opsparing</Button>
      </div>
      <div className={styles.scroll}>
        <div className={styles.inner}>
          <div className={styles.headRow2}>
            <div className={styles.goalCol}>Opsparing</div>
            {MONTH_SHORT.map((m, i) => (
              <div
                key={m}
                className={`${styles.monthCell} ${i === monthIdx ? styles.monthCurrent : ''}`}
              >
                {m}
              </div>
            ))}
          </div>
          {goals.map((g) => (
            <div key={g.id} className={styles.goalRow}>
              <div className={styles.goalNameWrap}>
                <input
                  className={styles.goalNameInput}
                  value={g.name}
                  onChange={(e) => onRenameGoal(g.id, e.target.value)}
                  onFocus={(e) => e.target.select()}
                />
                <button
                  type="button"
                  className={styles.deleteBtn}
                  onClick={() => onDeleteGoal(g.id, g.name)}
                  title={`Slet opsparingen ${g.name}`}
                  aria-label={`Slet opsparingen ${g.name}`}
                >
                  ×
                </button>
              </div>
              {MONTH_SHORT.map((_, m) => (
                <MoneyInput
                  key={m}
                  value={g.amounts[m] ?? null}
                  onCommit={(v) => onEditAmount(g.id, m, v)}
                  placeholder="—"
                />
              ))}
            </div>
          ))}
          <div className={styles.totalRow}>
            <div className={styles.totalLabel}>I alt</div>
            {totals.map((v, m) => (
              <div
                key={m}
                className={styles.totalCell}
                style={{ color: m === monthIdx ? 'var(--accent-dark)' : 'var(--text)' }}
              >
                {v === null ? '—' : fmtN(v)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
